<section>
    <button matButton [ngClass]="['primary-button']" [disabled]="!canEdit" (click)="saveAsReport()">{{ 'Save as' | i18next }}</button>
    <button matButton [ngClass]="['primary-button', 'save-button']" [disabled]="!canEdit || report?.subReportId == 0" (click)="saveReport()">{{ 'Save' | i18next }}</button>
    <button matButton [ngClass]="['secondary-button', 'cancel-button']" (click)="cancelClicked()">{{ 'Cancel' | i18next }}</button>
</section>
